module.exports = __webpack_public_path__ + "static/media/icot8-dark.ba213664.svg";